import { useUserTutorialCompleteMutation } from 'api/hooks'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'

export const useCompleteTutorial = () => {
  const [runMutation, { loading }] = useUserTutorialCompleteMutation()

  const completeTutorial = (page: string) => {
    return runMutation({
      variables: { page },
    })
  }

  return { completeTutorial, loading }
}

export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback)

  // Remember the latest callback if it changes.
  useLayoutEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (delay === null) {
      return
    }

    const id = setInterval(() => {
      savedCallback.current()
    }, delay)

    return () => {
      clearInterval(id)
    }
  }, [delay])
}

/**
 * Хук для поиска элемента в DOM с несколькими попытками.
 * @param selector - CSS-селектор для поиска .
 * @param delay - Задержка между попытками в мс.
 * @returns Найденный элемент или null.
 */
export const useFindElementWithRetry = (
  selector: string | undefined,
  delay = 500
) => {
  const [element, setElement] = useState<Element | null>(null)

  const find = () => {
    if (selector) {
      const el = document.querySelector(selector)
      setElement(el)
    } else {
      setElement(null)
    }
  }

  // Effect to not wait for interval when selector changed
  useEffect(find, [selector])

  useInterval(find, selector ? delay : null)

  return element
}
